import React, {useEffect,useState, useCallback, useRef, useContext } from 'react';


import {Card} from '@mui/material';


  import ReactFlow, {
    useNodesState, 
    useEdgesState,
    addEdge,
    MiniMap,
    Controls,
    Background
  } from 'reactflow';

  import 'reactflow/dist/style.css';
  import './style.css';


  import CmsContext from '../../../../../store/cms-context';

  import ContextMenu from './ContextMenu';



export default function FlowTasks(props) {

  const cmsContext = useContext(CmsContext);

  const [menu, setMenu] = useState(null);

  const ref = useRef(null);

  const [nodes, setNodes, onNodesChange] = useNodesState([]);

  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  const onConnect = useCallback(
    (params) => setEdges((els) => addEdge(params, els)),
    [setEdges],
  );


  const onNodeContextMenu = useCallback(
    (event, node) => {
      // Prevent native context menu from showing
      event.preventDefault();

      // Calculate position of the context menu. We want to make sure it
      // doesn't get positioned off-screen.
      const pane = ref.current.getBoundingClientRect();
      
      setMenu({
        id: node.id,
        data: node.data,
        top: 2,
        right: 2
      });

    },
    [setMenu],
    );



    function delete_node(id){

      const temp_node = nodes.filter((node) => node.id === id)

      if(temp_node.length === 0){
       // This should never happen
       cmsContext.setSnackBarOpen(true, "error", "Invalid node selected!")
       return
      }

      setMenu(null)

      props.post_sync_task(temp_node[0].data)

    }

    const onPaneClick = useCallback(() => setMenu(null), [setMenu]);

    useEffect(() => {

      const temp_tasks = props.all_tasks

      console.log("temp tasks were: ", temp_tasks)

      const temp_obj = {}

      for(var task in temp_tasks) {
        
        const temp_task = temp_tasks[task]

        if(!(temp_task.target.name in temp_obj)){

          temp_obj[temp_task.target.name] = []

        }

        temp_obj[temp_task.target.name].push(task)

      }

      var final_nodes = []

      var final_edges = []

      var total_indexes = 0

      console.log("temp obj was: ", temp_obj)

      for(var key in temp_obj){

        const index = parseInt(temp_obj[key])

        console.log("index was: ", index)

        const input_id = 'horizontal-'+total_indexes.toString()

        var source_count = 0;

        for(var task_id in temp_obj[key]) {

          total_indexes = total_indexes + 1

          const temp_obj = {
            id: 'horizontal-'+total_indexes.toString(),
            sourcePosition:'right',
            type:'input',
            data: { label: temp_tasks[task_id].source.name, type: "source",  index: task_id},
            position: { x: 100, y: total_indexes * 80},
          }

          const temp_edge = {
            id: 'horizontal-e1-'+(total_indexes + 1).toString(),
            target: input_id,
            source: 'horizontal-'+total_indexes.toString(),
            animated: true
          }

          final_nodes.push(temp_obj)

          final_edges.push(temp_edge)

          source_count = source_count + 1;

        }

        const input_obj = {
          id: input_id,
          targetPosition: 'left',
          type: 'output',
          className: 'dark-node',
          data: {  label: key, type: "target",  index: index},
          position: { x: 370, y: ((total_indexes * 80) - 40 * (source_count - 1))},
        }

        final_nodes.push(input_obj)

        total_indexes = total_indexes + 1

      }


      setNodes(final_nodes)

      setEdges(final_edges)


    },[props.all_tasks])




  return (

    <Card style={{width:'100%'}}>
    <div style={{width:'100%', height:'400px'}}>
    <ReactFlow
      ref={ref}
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
      onPaneClick={onPaneClick}
      selectNodesOnDrag={false}
      fitView
      onNodeContextMenu={onNodeContextMenu}
    >
       <MiniMap
        nodeStrokeColor={(n) => {
          if (n.type === 'input') return '#0041d0';
          if (n.type === 'selectorNode') return '#0041d0';
          if (n.type === 'output') return '#0041d0';
        }}
        nodeColor={(n) => {
          if (n.type === 'selectorNode') return '#0041d0';
          return '#0041d0';
        }}
      />
      <Controls />
      <Background color="#aaa" gap={16} />
      {menu && <ContextMenu delete_node={delete_node}  onClick={onPaneClick} {...menu} />}
    </ReactFlow>
    </div>
    </Card>
  );

}